import QuizNavigation from './QuizNavigation'
import QuizCountdownTimer from './QuizCountdownTimer'
import { useDispatch } from 'react-redux'

const QuizHeader = (props) => {
	let language = props.language || {}

	const quiz = props.quiz
	const dispatch = useDispatch()

	return (
		<div className='row justify-content-between'>
			<QuizNavigation {...props} quiz={quiz} />
			{/* {props.quizTimer && props.quizCount !== 0 ? (
				<div className='col-md-12'>
					<QuizCountdownTimer
						onEndCount={() => dispatch(props.onEndCount())}
						setQuizTimer={(count) => dispatch(props.setQuizTimer(count))}
						onUnmount={(count) => dispatch(props.onUnmount(count))}
						quizCount={props.quizCount}
					/>
				</div>
			) : null} */}
		</div>
	)
}

export default QuizHeader
